import { render } from "./Plans.vue?vue&type=template&id=c5da1608&scoped=true&lang=pug"
import script from "./Plans.vue?vue&type=script&setup=true&lang=js"
export * from "./Plans.vue?vue&type=script&setup=true&lang=js"

import "./Plans.vue?vue&type=style&index=0&id=c5da1608&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5da1608"]])

export default __exports__